import {Component, OnInit} from "@angular/core";
import {Member, MemberPage, MemberTeamPage} from "../../service/member/member";
import {MemberService} from "../../service/member/member.service";
import {AuthService} from "../../service/auth/auth.service";
import {CommonService} from "../../service/common/common.service";
import {ActivatedRoute, Router} from "@angular/router";
import {GtmService} from "../../service/gtm/gtm.service";

@Component({
  selector: 'app-member-board',
  templateUrl: './member-board.component.html',
  styleUrls: ['./member-board.component.scss'],
  providers: [MemberService]
})
export class MemberBoardComponent implements OnInit {
  teams: MemberTeamPage;
  members: MemberPage;

  constructor(private memberService: MemberService,
              private authService: AuthService,
              private route: ActivatedRoute,
              private router: Router,
              private commonService: CommonService,
              private gtmService: GtmService) {
  }

  onCanUpdate(): boolean {
    return this.authService.isAdmin() || this.authService.isManager();
  }

  ngOnInit() {
    this.route.queryParams.subscribe(
      params => {
        this.tpage    = params['tpage']     ? +params['tpage']   : 1;
        this.upage    = params['upage']     ? +params['upage']   : 1;
        this.search   = params['search']    ? params['search']   : '';
        this.type     = params['type']      ? params['type']     : 'team';
        this.location = params['location']  ? params['location'] : '';
        this.sort     = params['sort']      ? params['sort']     : 'interest';

        if(this.sort === 'interest' || this.sort === 'work') this.order = 'DESC'
        else                                                 this.order = 'ASC'

        if(this.type == 'team') {
          this.getTeams();
        } else {
          this.getMembers();
        }

        this.gtmService.pageViewWithPage({
          'path': this.route.snapshot['_routerState'].url,
          'title': 'Members',
          'breadcrumb': 'Home > Member > Members'
        });
      }
    );
  }

  getTeams() {
    this.memberService.getTeams(this.tpage, this.location, this.search).subscribe(
      teams => this.teams = teams
    );
  }

  getMembers() {
    this.memberService.get(this.upage, this.search, this.sort, this.order).subscribe(
      members => this.members = members
    );
  }


  onSendMessage(member: Member) {
    this.commonService.addMessageEvent(member);
  }

  showProfile(email: string) {
    this.commonService.addProfileEvent(email);
  }

  reload() {
    let url = this.router.url.split('?')[0];

    this.router.navigateByUrl(
      `${url}?` +
      `${this.upage    ? `&upage=${this.upage}`: ''}` +
      `${this.tpage    ? `&tpage=${this.tpage}`: ''}` +
      `${this.type     ? `&type=${this.type}`: ''}` +
      `${this.location ? `&location=${this.location}`: ''}` +
      `${this.sort     ? `&sort=${this.sort}`: ''}` +
      `${this.search   ? `&search=${this.search}`: ''}`);
  }

  type: string;
  onType(type: string) {
    if(this.type == type) return;
    this.type = type;
    this.search = '';
    this.reload();
  }
  search: string;
  onSearch(term: string) {
    if(this.type == 'user') this.upage = 1;
    else this.tpage = 1;

    this.search = term;
    this.reload();
  }

  upage: number = 1;
  onUserPageChanged(event: any) {
    if (event.page == this.upage) return;
    this.upage = event.page;
    this.reload();
  }

  order: string;
  sort: string;
  onSort(sort: string) {
    this.upage = 1;
    this.sort = sort;

    if(sort === 'interest' || sort === 'work') this.order = 'DESC'
    else                                       this.order = 'ASC'

    this.reload();
  }

  tpage: number = 1;
  onTeamPageChanged(event: any) {
    if (event.page == this.tpage) return;
    this.tpage = event.page;
    this.reload();
  }
  location: string;
  onLocation(location: string) {
    this.location = location
    this.reload();
  }
}



// WEBPACK FOOTER //
// ./src/app/member/member-board/member-board.component.ts